module.exports = __webpack_public_path__ + "assets/img/chirp-post-active.f509eb7b.svg";